// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"c2d2af39","455":"269c465f","977":"e6be10dd"}[chunkId] + ".chunk.js";
};